<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'studentSubscription',
  props: ['value', 'serviceSubscriptionResource', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  computed: {
    feeSetupByFeeType: vm => feeTypeId => {
      if (
        feeTypeId !== undefined &&
        vm.serviceSubscriptionResource.feeSetups !== undefined
      ) {
        return vm.serviceSubscriptionResource.feeSetups
          .filter(inv => inv.fee_type_id === feeTypeId)
          .map(el => ({
            value: el.fee_setup_id,
            label: el.fee_name_en,
            ...el
          }))
      }
      return []
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<template>
  <div>
    <h3 class="ts-uppercase ts-font-semibold ts-text-blue-800 ts-text-base">
      {{ $t('studentTransfer.subscription') }}
    </h3>

    <table class="ts-w-full ts-mt-3">
      <thead>
        <tr>
          <th
            class="ts-uppercase ts-font-semibold ts-py-1 ts-px-2 ts-bg-gray-200 ts-w-8"
          >
            {{ $t('studentTransfer.no') }}
          </th>
          <th
            class="ts-uppercase ts-font-semibold ts-py-1 ts-px-2 ts-bg-gray-200 ts-w-56"
          >
            {{ $t('studentTransfer.feeType') }}
          </th>
          <th
            class="ts-uppercase ts-font-semibold ts-py-1 ts-px-2 ts-bg-gray-200 ts-w-64"
          >
            {{ $t('studentTransfer.fee') }}
          </th>
          <th
            class="ts-uppercase ts-font-semibold ts-py-1 ts-px-2 ts-bg-gray-200"
          >
            {{ $t('studentTransfer.toFee') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(inv, index) in model.serviceSubscription" :key="index">
          <td class="ts-px-2 ts-py-1">{{ index + 1 }}</td>
          <td class="ts-px-2 ts-py-1">{{ inv.fee_type_name }}</td>
          <td class="ts-px-2 ts-py-1">{{ inv.fee_name_en }}</td>
          <td class="ts-px-2 ts-py-1">
            <a-select
              v-model="inv.to_fee_setup_id"
              :options="feeSetupByFeeType(inv.fee_type_id)"
              class="ts-w-full"
              showSearch
              :filterOption="filterOption"
              optionFilterProp="children"
            ></a-select>
            <div
              class="ts-text-red-500"
              v-if="errors.has(`serviceSubscription.${index}.to_fee_setup_id`)"
            >
              {{ errors.first(`serviceSubscription.${index}.to_fee_setup_id`) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
